import styled from '@emotion/styled';
import { Breadcrumb, Divider, Image, Space } from 'antd';
import { FaHome } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import { ROUTES } from '../../../routes';
import { ORANGE, YELLOW } from '../../../shared/colors';
import { Footer } from '../../homePage/components/Footer';
import { Layout } from '../../shared/Layout';
import { SubmenuFisca } from '../components/Submenu';

const Container = styled.div`
  // height: calc(100vh - 32px);
  background-color: white;

  .banner {
    height: 300px;
    background-color: white;
    background-image: url('assets/images/fisca.jpg');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;

    > .black-background {
      padding: 5% 15% 5% 15%;
      background-color: rgba(0, 0, 0, 0.6);
      width: 100%;
      height: 100%;
    }

    .bread-crumb {
      font-size: 14px;
      margin-top: 10px;

      span {
        color: white;
        font-family: Poppins-L;
      }
    }

    .link {
      text-decoration: underline;
      cursor: pointer;
    }

    .menus {
      display: flex;

      > p {
        text-transform: uppercase;
        font-family: Poppins-L;
        font-size: 14px;
        padding: 4.5px 5px;
        margin-right: 0px;
        text-align: center;

        &:hover {
          background-color: ${YELLOW};
          cursor: pointer;
        }
      }

      .active {
        background-color: ${YELLOW};
      }
    }
  }

  > .content {
    min-height: 400px;
    background-color: white;
    color: black;
    padding: 2% 15%;

    > h2 {
      font-family: Poppins-B;
      font-size: 25px;
      margin-bottom: 15px;
    }

    > div {
      display: flex;
      flex-wrap: wrap;
      margin-top: 25px;
    }
  }

  .text {
    font-size: 16px;
    color: #424242;
  }
`;

export const ComptaFinanPage = () => {
  const history = useHistory();

  return (
    <Layout>
      <Container>
        <div className='banner'>
          <div className='black-background'>
            <Space size={10}>
              <Image
                alt='moranje-logo'
                src='assets/images/moranje-logo.png'
                // height={250}
                width={130}
                preview={false}
                style={{ objectFit: 'contain', cursor: 'pointer' }}
              />
              <div>
                <div
                  style={{
                    fontFamily: 'Poppins-B',
                    fontSize: 35,
                  }}
                >
                  <span style={{ color: ORANGE }}>Moranj</span>
                  <span style={{ color: '#6d4c41' }}>E</span>
                  <span style={{ color: YELLOW }}>trade</span>
                </div>
                <div
                  style={{
                    fontFamily: 'Poppins-B',
                    fontSize: 30,
                  }}
                >
                  Fiscalité & Comptabilité
                </div>
              </div>
            </Space>
            <Breadcrumb separator='>' className='bread-crumb'>
              <Breadcrumb.Item>
                <FaHome style={{ marginRight: 5 }} />
                <span>Accueil</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item onClick={() => history.push(ROUTES.FISCA.PAGE)}>
                <span className='link'>Fiscalité & Comptabilité</span>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <span>Introduction à la comptabilité financière</span>
              </Breadcrumb.Item>
            </Breadcrumb>
            <Divider style={{ backgroundColor: 'white', marginBottom: 0 }} />

            <div className='menus'>
              {SubmenuFisca('1').map((form, i) => (
                <p
                  className={form.color ? 'active' : ''}
                  key={i}
                  onClick={() => history.push(form.link)}
                >
                  {form.sumaryLabel}
                </p>
              ))}
            </div>
          </div>
        </div>

        <div className='content'>
          <h2>Introduction à la comptabilité financière</h2>
          <p className='text'>
            In progress.... <br /> In progress...
            <br />
            <br />
            In progress...
          </p>
        </div>

        <div style={{ backgroundColor: 'white' }}>
          <Footer />
        </div>
      </Container>
    </Layout>
  );
};
